import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, EventManager } from '@angular/platform-browser';
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { HereMapComponent } from '../here-map/here-map.component'
import { HereService } from '../here.service';
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { PageEvent } from '@angular/material/paginator';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { find, map, startWith } from 'rxjs/operators';
import { VariablesGlobales } from '../services/globals';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-annonces',
  templateUrl: './annonces.component.html',
  styleUrls: ['./annonces.component.css']
})
export class AnnoncesComponent implements OnInit {

  @ViewChild('map')
  private mapComponent: HereMapComponent;

  @ViewChild('baseHeight')
  private heightBase: ElementRef;

  public annonces: AnnonceLite[];
  public annoncesFilter: AnnonceLite[];
  public error: string;

  public isLoading = true;

  public fond: boolean = false;
  public mono: boolean = false;

  public isMobile: boolean = false;

  config = ConfigService.GetItem;

  // MatPaginator Inputs
  length = 100;
  pageSize = 12;
  pageSizeOptions: number[] = [12, 24, 48, 96];

  // MatPaginator Output
  pageEvent: PageEvent;

  emploiFonction: Fonction[] = [];
  posteContrat: Contrat[] = [];
  regions: Region[] = [];

  public toppings = new FormControl();
  public toppingsFonc = new FormControl();
  public toppingsRegions = new FormControl();
  public toppingsSocs = new FormControl();
  filter: string = "";

  public currentContrat: string[];

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

  safeCss(style) {
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }

  constructor(private encdec: EncryptDecryptService,
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private eventManager: EventManager,
    private router: Router,
    public param: VariablesGlobales,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer) {

    let idGroupe: any;
    this.route.queryParams.subscribe(params => {
      idGroupe = params['idgroupe'];
    });
    console.log(idGroupe);

    http.get('https://api2.sitederecrutement.com/Home/GetAnnoncesBisTest?apikey=' + localStorage.getItem('apikey') + '&idgroupe=' + idGroupe, { responseType: "text" }).subscribe(result => {
      if (result.includes('{Error:')) {
        this.error = result;
        this.annonces = [];
      }
      else {
        const obj = JSON.parse(this.encdec.getDecrypt(result));
        this.annonces = obj;
      }
      this.setInfos();
      this.annoncesFilter = this.annonces;

      this.length = this.annoncesFilter.length;
    }, error => console.error(error));
    this.eventManager.addGlobalEventListener('window', 'resize', this.OnResize.bind(this));
  }

  getSocietes() {
    let socs: string[] = [];
    if (this.annoncesFilter)
      this.annoncesFilter.forEach(x => {
        if (!socs.includes(x.societe_groupe))
          socs.push(x.societe_groupe);
      });
    return socs;
  }

  lowText(text, length): string {
    if (text && text.length > length)
      return text.replace('&nbsp;', ' ').substr(0, length).replace(/<(?:.|\n)*?>/gm, '') + '...';
    return text;
  }

  setInfos(): void {
    // Requete API pour avoir les différentes fonctions
    this.http.get('https://api2.sitederecrutement.com/Home/getinfos?apikey=' + localStorage.getItem('apikey'), { responseType: "text" }).subscribe(
      result => {
        const jsonData = this.encdec.getDecrypt(result);
        let jsonObject: any = JSON.parse(jsonData);
        // Parse JSON dans nos variables
        this.emploiFonction = jsonObject.fonctions.slice(1);
        this.emploiFonction.sort((a, b) => a.fonction.localeCompare(b.fonction));

        this.posteContrat = jsonObject.contrats.slice(1).filter(c => {
          if (this.countContratsGlo(c.contrat) > 0)
            return true;
          return false;
        });
        this.regions = jsonObject.regions.slice(1).filter(region => {
          if (this.countRegionsGlo(region.region) > 0)
            return true;
          return false;
        });
        this.regions.sort((a, b) => a.region.localeCompare(b.region));

        this.allFruits = this.regions.map(x => x.region);
        this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
          startWith(null),
          map((fruit: string | null) => fruit ? this._filter(fruit) : this.allFruits.slice()));
        // récupération des querystrings
        this.route.queryParams.subscribe(params => {
          let ids = params['fonction']; // --> Name must match wanted parameter
          if (ids) {
            let datas: string[] = ids.split(',');
            let fonctions: string[] = [];
            datas.forEach(x => {
              fonctions.push(this.emploiFonction.find(y => y.idfonction.toString() == x).fonction);
            });
            this.toppingsFonc.setValue(fonctions);
            this.applyFilter();
          }
        });
        //console.log(this.emploiFonction);
        this.isLoading = false;
      }
    );
  }

  comparer(otherArray) {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.value == current.value && other.display == current.display
      }).length == 0;
    }
  }

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;
  fruits: string[] = [];
  allFruits: string[];

  tops: string[];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
    this.applyFilter();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    //console.log(event);
    this.fruits.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
    this.applyFilter();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFruits.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {
  }

  applyFilter() {
    this.annoncesFilter = this.filtreTexte(this.annonces, this.filter);
    var tops = this.toppings;
    if (tops?.value && tops?.value.length > 0) {
      this.annoncesFilter = this.annoncesFilter.filter(function (el) {
        const even = (element) => tops.value.indexOf(element) >= 0;
        return el.contrats.split(';').some(even);
      });
    }
    tops = this.toppingsFonc;
    if (tops?.value && tops?.value.length > 0) {
      this.annoncesFilter = this.annoncesFilter.filter(function (el) {
        const even = (element) => tops.value.indexOf(element) >= 0;
        return el.fonctions.split(';').some(even);
      });
    }
    tops = this.toppingsRegions;
    if (tops?.value && tops?.value.length > 0) {
      this.annoncesFilter = this.annoncesFilter.filter(function (el) {
        const even = (element) => tops.value.indexOf(element) >= 0;
        return el.regions.split(';').some(even);
      });
    }
    tops = this.toppingsSocs;
    if (tops?.value && tops?.value.length > 0) {
      this.annoncesFilter = this.annoncesFilter.filter(function (el) {
        const even = (element) => tops.value.indexOf(element) >= 0;
        return el.societe_groupe.split(';').some(even);
      });
    }
    this.length = this.annoncesFilter.length;
  }

  filtreTexte(arr, requete) {
    return arr.filter(function (el) {
      return el.intitule.toLowerCase().indexOf(requete.toLowerCase()) !== -1
        || el.ville.toLowerCase().indexOf(requete.toLowerCase()) !== -1;
    });
  }

  private OnResize(event: any) {
    if (window.screen.width >= 768) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
    //this.mapComponent.resize();
  }

  private lastHeight: number;

  ngAfterViewChecked() {
    if (window.screen.width >= 768) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }

  public goToAnnonce(id) {
    event.preventDefault();
    VariablesGlobales.annonceInfos = this.annonces.find(x => x.idannonce == id);
    this.router.navigate(['/annonce-read', id]);
  }

  public onClickMarker(id) {

  }

  public countContrats(txt): number {
    return this.annoncesFilter.filter(val => {
      if (val.contrats.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }

  public countContratsGlo(txt): number {
    return this.annonces.filter(val => {
      if (val.contrats.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }

  public countFonctions(txt): number {
    return this.annoncesFilter.filter(val => {
      if (val.fonctions.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }

  public countFonctionsGlo(txt): number {
    return this.annonces.filter(val => {
      if (val.fonctions.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }

  public countSocs(txt): number {
    return this.annoncesFilter.filter(val => {
      if (val.societe_groupe.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }

  public countRegions(txt): number {
    return this.annoncesFilter.filter(val => {
      if (val.regions.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }

  public countRegionsGlo(txt): number {
    return this.annonces.filter(val => {
      if (val.regions.replace('&amp;', '&').includes(txt))
        return true;
      return false;
    }).length;
  }



}

interface AnnonceLite {
  idannonce: number;
  intitule: string;
  emp_adresse1: string;
  emp_code_postal: string;
  emp_ville: string;
  contrats: string;
  societe_adresse: string;
  societe_cp: string;
  societe_ville: string;
  societe_logo: string;
  societe_groupe: string;
  ref: string;
  previsu: string;
  niveau_formation: string;
  regions: string;
  fonctions: string;
}

interface Contrat {
  idcontrat: number;
  contrat: string;
}

interface Fonction {
  idfonction: number;
  fonction: string;
}

interface Region {
  idregion: number;
  region: string;
}
